import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

export const ReadingHeader = ({ id, category, title, intro }) => (
  <motion.header initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="reading-header" data-testid={`${id}-header`}>
    <Link to="/" className="reading-breadcrumb" data-testid={`${id}-overview-link`}><ArrowLeft size={12} aria-hidden="true" /> Graph of Life <span>/ {category}</span></Link>
    <h1 data-testid={`${id}-heading`}>{title}</h1>
    <p data-testid={`${id}-intro`}>{intro}</p>
  </motion.header>
);